import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedTranslationModule } from '@shared/translation.module';

@Component({
  selector: 'md-page-section-header',
  imports: [TranslateModule, SharedTranslationModule],
  templateUrl: './page-section-header.component.html',
  styleUrl: './page-section-header.component.scss',
  standalone: true
})
export class PageSectionHeaderComponent {
  title = input<string>('');
}
